import GasMixCalculator from './components/GasMixCalculator';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <GasMixCalculator />
    </ThemeProvider>
  );
}

export default App